import React from "react";

import Tooltip from "../Tooltip";

import { UnsupportedText } from "./styled";

const UNSUPPORTED_TOOLTIP_COPY =
  "This file wasn't recognized as a supported income document type.";

const UnsupportedLabel = () => (
  <Tooltip title={UNSUPPORTED_TOOLTIP_COPY} theme="dark">
    <UnsupportedText>Unsupported</UnsupportedText>
  </Tooltip>
);

export default UnsupportedLabel;
